import React from "react";
import { View, Text } from "react-native";
import Animated, { FadeInDown } from "react-native-reanimated";
import i18n from "../../locales/i18n";

interface TotalDisplayProps {
  totalPrice: number;
  locale: string;
}

const TotalDisplay: React.FC<TotalDisplayProps> = ({ totalPrice, locale }) => {
  return (
    <Animated.View
      entering={FadeInDown.duration(400).springify()}
      className="mx-4 mb-4"
    >
      <View
        className="bg-white rounded-lg px-6 py-4"
        style={{
          shadowColor: "#000",
          shadowOffset: {
            width: 0,
            height: 2,
          },
          shadowOpacity: 0.1,
          shadowRadius: 3.84,
          elevation: 5,
        }}
      >
        <View
          className={`${
            locale === "ar" ? "flex-row-reverse" : "flex-row"
          } justify-between items-center`}
        >
          <Text className="text-gray-700 text-xl font-semibold">
            {i18n.t("totalColon")}
          </Text>
          <Text className="text-2xl font-bold text-gray-900">
            {totalPrice} {i18n.t("currency")}
          </Text>
        </View>
      </View>
    </Animated.View>
  );
};

export default TotalDisplay;
